import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import { parse, format } from "url";
var _templateString = /*#__PURE__*/new _WeakMap();
var _variables = /*#__PURE__*/new _WeakMap();
var _replacer = /*#__PURE__*/new _WeakMap();
export default class UrlTemplate {
  constructor(templateString, variables) {
    _classPrivateFieldInitSpec(this, _templateString, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _variables, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _replacer, {
      writable: true,
      value: (_match, capture) => {
        if (Object.prototype.hasOwnProperty.call(_classPrivateFieldGet(this, _variables), capture)) {
          return _classPrivateFieldGet(this, _variables)[capture];
        }
        throw new Error(`Unspecified template variable: ${capture}`);
      }
    });
    _classPrivateFieldSet(this, _templateString, templateString);
    _classPrivateFieldSet(this, _variables, variables);
  }
  set(key, value) {
    _classPrivateFieldGet(this, _variables)[key] = value;
  }
  toString() {
    const url = parse(_classPrivateFieldGet(this, _templateString));
    url.pathname = decodeURIComponent(url.pathname || '').replace(/\{([A-Za-z_$]+)\}/g, _classPrivateFieldGet(this, _replacer)).replace(/\/{2,}/g, '/');
    return format(url);
  }
  toJSON() {
    return this.toString();
  }
}